export default {
	'pajoohyar.appName': 'پژوهیار',
	'general.etAl': 'و دیگران',
	'general.back': 'بازگشت',
	'general.thanksForHelpingImprove': 'از اینکه به بهبود %S کمک می‌کنید، سپاسگزاریم!',
	'general.tryAgain': 'دوباره تلاش کنید',
	'general.updateAvailable': 'به‌روزرسانی موجود است',
	'general.copyToClipboard': 'رونوشت در کلیپ‌بورد',
	'general.finished': 'تمام شد',
	'general.checkForUpdates': 'بررسی به‌روزرسانی‌ها',
	'general.keys.cmdShift': 'Cmd+Shift+',
	'general.clear': 'پاک کردن',
	'general.failed': 'ناموفق',
	'general.restartLater': 'بعداً راه‌اندازی مجدد',
	'general.unknownErrorOccurred': 'خطای ناشناخته‌ای رخ داد.',
	'general.dontShowAgainFor': 'امروز دیگر نمایش نده؛برای %1$S روز دیگر نمایش نده',
	'general.permissionDenied': 'دسترسی ممنوع',
	'general.checkForUpdate': 'بررسی به‌روزرسانی',
	'general.moreInformation': 'اطلاعات بیشتر',
	'general.quitApp': 'خروج از %S',
	'general.errorHasOccurred': 'خطایی رخ داده است.',
	'general.and': 'و',
	'general.isUpToDate': '%S به‌روز است.',
	'general.seeForMoreInformation': 'برای اطلاعات بیشتر به %S مراجعه کنید.',
	'general.success': 'موفقیت',
	'general.submitted': 'ارسال شده',
	'general.character.plural': 'کاراکترها',
	'general.locate': 'یافتن…',
	'general.restartNow': 'اکنون راه‌اندازی مجدد',
	'general.pleaseRestart': 'لطفاً %S را راه‌اندازی مجدد کنید.',
	'general.quit': 'خروج',
	'general.hide': 'پنهان کردن',
	'general.browserIsOffline': '%S در حال حاضر در حالت آفلاین است.',
	'general.error': 'خطا',
	'general.import': 'وارد کردن',
	'general.warning': 'هشدار',
	'general.yes': 'بله',
	'general.useDefault': 'استفاده از پیش‌فرض',
	'general.fix': 'رفع…',
	'general.restartRequiredForChanges': 'برای اعمال تغییرات باید پژوهیار راه‌اندازی مجدد شود.',
	'general.accessDenied': 'دسترسی رد شد',
	'general.continue': 'ادامه',
	'general.dontShowAgain': 'دیگر نمایش نده',
	'general.copy': 'کپی',
	'general.keys.ctrlShift': 'Ctrl+Shift+',
	'general.create': 'ایجاد',
	'general.export': 'صادر کردن',
	'general.noUpdatesFound': 'هیچ به‌روزرسانی‌ای یافت نشد',
	'general.restartRequired': 'نیاز به راه‌اندازی مجدد',
	'general.actionCannotBeUndone': 'این عمل قابل بازگشت نیست.',
	'general.pdf': 'PDF',
	'general.remove': 'حذف',
	'general.cancel': 'انصراف',
	'general.tryLater': 'بعداً تلاش کنید',
	'general.operationInProgress.waitUntilFinishedAndTryAgain': 'لطفاً تا پایان عملیات صبر کنید و دوباره تلاش کنید.',
	'general.processing': 'در حال پردازش',
	'general.disable': 'غیرفعال کردن',
	'general.restartApp': 'راه‌اندازی مجدد %S',
	'general.enable': 'فعال کردن',
	'general.showDirectory': 'نمایش پوشه',
	'general.passed': 'قبول شد',
	'general.invalidResponseServer': 'پاسخ نامعتبر از سرور.',
	'general.reset': 'بازنشانی',
	'general.nMegabytes': '%S مگابایت',
	'general.numMore': '%S بیشتر…',
	'general.serverError': 'سرور خطا داد. لطفاً دوباره تلاش کنید.',
	'general.upgrade': 'ارتقا',
	'general.open': 'باز کردن %S',
	'general.openPreferences': 'باز کردن تنظیمات',
	'general.describeProblem': 'مشکل را به‌طور مختصر شرح دهید:',
	'general.pleaseRestartAndTryAgain': 'لطفاً %S را راه‌اندازی مجدد کرده و دوباره تلاش کنید.',
	'general.operationInProgress.waitUntilFinished': 'لطفاً تا پایان عملیات صبر کنید.',
	'general.dontShowWarningAgain': 'این هشدار دیگر نمایش داده نشود.',
	'general.notNow': 'فعلاً نه',
	'general.item': 'مورد',
	'general.restartRequiredForChange': 'برای اعمال تغییر باید پژوهیار راه‌اندازی مجدد شود.',
	'general.character.singular': 'کاراکتر',
	'general.operationInProgress': 'عملیات پژوهیار در حال انجام است.',
	'general.no': 'خیر',
	'general.delete': 'حذف',
	'general.openDocumentation': 'باز کردن مستندات',
	'general.tryAgainLater': 'لطفاً چند دقیقه بعد دوباره تلاش کنید.',
	'general.install': 'نصب',
	'general.yellow': 'زرد',
	'general.red': 'قرمز',
	'general.green': 'سبز',
	'general.blue': 'آبی',
	'general.purple': 'بنفش',
	'general.magenta': 'صورتی',
	'general.orange': 'نارنجی',
	'general.gray': 'خاکستری',
	'general.showInLibrary': 'نمایش در کتابخانه',
	'pdfReader.annotations': 'حاشیه‌نویسی‌ها',
	'pdfReader.showAnnotations': 'نمایش حاشیه‌نویسی‌ها',
	'pdfReader.searchAnnotations': 'جستجوی حاشیه‌نویسی‌ها',
	'pdfReader.noAnnotations': 'یک حاشیه‌نویسی ایجاد کنید تا در کناری نمایش داده شود',
	'pdfReader.noExtractedText': 'متنی استخراج نشده است',
	'pdfReader.addComment': 'افزودن نظر',
	'pdfReader.addTags': 'افزودن برچسب‌ها…',
	'pdfReader.highlightText': 'برجسته‌سازی متن',
	'pdfReader.addNote': 'افزودن یادداشت',
	'pdfReader.selectArea': 'انتخاب ناحیه',
	'pdfReader.pickColor': 'انتخاب رنگ',
	'pdfReader.addToNote': 'افزودن به یادداشت',
	'pdfReader.zoomIn': 'بزرگ‌نمایی',
	'pdfReader.zoomOut': 'کوچک‌نمایی',
	'pdfReader.zoomAuto': 'تغییر اندازه خودکار',
	'pdfReader.zoomPageWidth': 'بزرگ‌نمایی به عرض صفحه',
	'pdfReader.nextPage': 'صفحه بعد',
	'pdfReader.previousPage': 'صفحه قبل',
	'pdfReader.page': 'صفحه',
	'pdfReader.readOnly': 'فقط خواندنی',
	'pdfReader.promptTransferFromPDF.title': 'وارد کردن حاشیه‌نویسی‌ها',
	'pdfReader.promptTransferFromPDF.text': 'حاشیه‌نویسی‌های ذخیره شده در فایل PDF به %1$S منتقل خواهند شد.',
	'pdfReader.promptTransferToPDF.title': 'ذخیره حاشیه‌نویسی‌ها در فایل',
	'pdfReader.promptTransferToPDF.text': 'حاشیه‌نویسی‌ها به فایل PDF منتقل شده و دیگر قابل ویرایش در %S نخواهند بود.',
	'pdfReader.promptPasswordProtected': 'این عملیات برای فایل‌های PDF محافظت‌شده با رمز عبور پشتیبانی نمی‌شود.',
	'pdfReader.editPageNumber': 'ویرایش شماره صفحه…',
	'pdfReader.editHighlightedText': 'ویرایش متن برجسته‌شده',
	'pdfReader.pageNumberPopupHeader': 'تغییر شماره صفحه برای:',
	'pdfReader.thisAnnotation': 'این حاشیه‌نویسی',
	'pdfReader.selectedAnnotations': 'حاشیه‌نویسی‌های انتخاب‌شده',
	'pdfReader.thisPage': 'این صفحه',
	'pdfReader.thisPageAndLaterPages': 'این صفحه و صفحات بعد',
	'pdfReader.allPages': 'تمام صفحات',
	'pdfReader.autoDetect': 'شناسایی خودکار',
	'pdfReader.deleteAnnotation.singular': 'آیا مطمئن هستید که می‌خواهید حاشیه‌نویسی انتخاب‌شده را حذف کنید؟',
	'pdfReader.deleteAnnotation.plural': 'آیا مطمئن هستید که می‌خواهید حاشیه‌نویسی‌های انتخاب‌شده را حذف کنید؟'
};
